import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./root";
import { getWordpressVars } from "@lib/wordpressVars";

type WordpressState = {
  ID: number | null;
  title: string | null;
  date: string | null;
  template: string | null;
  slug: string | null;
  blocks: Array<string>;
  type: string | null;
  root: string | null;
  nonce: string | null;
  mediaRoot: string | null;
  domain: string | null;
};

const initialState = { ...getWordpressVars() } as WordpressState;

const wordpressSlice = createSlice({
  name: "wordpress",
  initialState,
  reducers: {
    setWordpressNonce(state, action: PayloadAction<string>) {
      state.nonce = action.payload;
    },
  },
});

export const getWordpressBlocks = (state: RootState) => state.wordpress.blocks; // Selector

export const getWordpressType = (state: RootState) => state.wordpress.type; // Selector

export const getWordpressRoot = (state: RootState) => state.wordpress.root; // Selector

export const getWordpressNonce = (state: RootState) => state.wordpress.nonce; // Selector

export const { setWordpressNonce } = wordpressSlice.actions; // Auto-generated action

export default wordpressSlice.reducer;
